export default __webpack_public_path__ + "static/media/mini-gold-card@2x.87d072b4.png";